import axios from "axios";

const buildQueryString = (name, email) => {
    if (name && email) {
        return `?name=${name}&email=${email}`;
    } else if (name && !email) {
        return `?name=${name}`;
    } else if (!name && email) {
        return `?email=${email}`;
    } else {
        return "";
    }
};

export const searchPeople = async (name, email) => {
    if (!name && !email) { throw new Error("Please provide either name or email"); }
    const queryString = buildQueryString(name, email);
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/person${queryString}`);
    return response.data;
}